const CHIAVE_OFFUSCAMENTO = 'W4p00@Nlt_0bfK3y#2026!xZq';

export function decodificaPayload(payloadCodificato) {
  const binario = atob(payloadCodificato);
  const buffer = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i++) {
    buffer[i] = binario.charCodeAt(i);
  }

  const chiave = new TextEncoder().encode(CHIAVE_OFFUSCAMENTO);
  for (let i = 0; i < buffer.length; i++) {
    buffer[i] = buffer[i] ^ chiave[i % chiave.length];
  }

  const jsonStr = new TextDecoder().decode(buffer);
  return JSON.parse(jsonStr);
}

export function isRispostaCodificata(data) {
  return data && typeof data === 'object' && typeof data._p === 'string' && Object.keys(data).length === 1;
}
